import React from 'react';
import TopicTreeBrowser from './TopicTreeBrowser';

// Helper
import Page from '../../lib/page';

const topicLabels = Page.getTopicLabels();


const TopicTreeSwitch = () => (
  <div className="topic-tree-switcher">
    <TopicTreeBrowser topicLabels={topicLabels} />
  </div>
);


export default TopicTreeSwitch;
